export { WebNavigationService } from './WebNavigationService'
export { WebPlatformService } from './WebPlatformService'
export { WebStorageService } from './WebStorageService'
export { WebAddressService } from './WebAddressService'
export { WebOrderTrackingService } from './WebOrderTrackingService'
export { WebOffersService } from './WebOffersService'
export { WebOffersPageService } from './WebOffersPageService'
export { WebRewardsPageService } from './WebRewardsPageService'
export { WebFavoritesPageService } from './WebFavoritesPageService'
export { WebAccountPageService } from './WebAccountPageService'
export { WebEditAccountPageService } from './WebEditAccountPageService'
export { WebNotificationsPageService } from './WebNotificationsPageService'
export { WebHelpPageService } from './WebHelpPageService'
export { WebLocationService } from './WebLocationService'
export { createMockServiceConfig, createMockApiClient, createMockLogger } from './mockServices'

import { WebNavigationService } from './WebNavigationService'
import { WebPlatformService } from './WebPlatformService'
import { WebStorageService } from './WebStorageService'
import type { IPlatformServices } from '../../contracts'

/**
 * Creates web platform services for use with ViewModels
 * Requires React Router's navigate and location to be passed in
 */
export const createWebPlatformServices = (
  navigate: (path: string, options?: { replace?: boolean }) => void,
  location: { pathname: string; search: string }
): IPlatformServices => ({
  navigationService: new WebNavigationService(navigate, location),
  platformService: new WebPlatformService(),
  storageService: new WebStorageService(), // Uses localStorage by default
})